<template>
    <div class="border rounded p-3 mb-3">
        <div class="fw-semibold mb-2">
            GPS Gap Analysis
            <span v-if="gaps.length > 0" class="badge bg-warning text-dark ms-2">
                {{ gaps.length }} gap{{ gaps.length > 1 ? 's' : '' }} &gt; 5 min
            </span>
            <span v-else class="badge bg-success ms-2">No significant gaps</span>
        </div>

        <div v-if="gaps.length === 0" class="text-muted small">
            All consecutive GPS points are within 5 minutes of each other. Good coverage.
        </div>
        <div v-else>
            <div class="text-muted small mb-2">
                Gaps indicate periods where no GPS points were uploaded — the vehicle may have been offline or location tracking paused.
            </div>
            <table class="table table-sm table-bordered mb-0" style="font-size:0.82rem;">
                <thead class="table-light">
                    <tr>
                        <th>From</th>
                        <th>To</th>
                        <th>Gap duration</th>
                        <th>Likely segment</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="gap in gaps" :key="gap.fromTime">
                        <td>{{ gap.fromTime }}</td>
                        <td>{{ gap.toTime }}</td>
                        <td :class="gap.durationMin > 15 ? 'text-danger fw-bold' : 'text-warning'">
                            {{ gap.durationMin }} min
                        </td>
                        <td class="text-muted">{{ gap.segment }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    gaps: Array<{ fromTime: string; toTime: string; durationMin: number; segment: string }>;
}>();
</script>
